<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="stars d-flex">
        <img :src="starSrc1" height="40" width="40" @click="onClickStar(1)" />
        <img :src="starSrc2" height="40" width="40" @click="onClickStar(2)" />
        <img :src="starSrc3" height="40" width="40" @click="onClickStar(3)" />
        <img :src="starSrc4" height="40" width="40" @click="onClickStar(4)" />
        <img :src="starSrc5" height="40" width="40" @click="onClickStar(5)" />
      </div>
      <p v-if="value" class="text-gray-05 text-size-14 mt-1 ml-2">
        {{ value }}点
      </p>
    </div>
    <FormInvalidFeedback :validation-state="validationState" :state="false" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import { ValidationStateType } from "@/types/Validation";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const FILLED_STAR_PATH = require("@/assets/svg/star/filled_star.svg");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const GRAY_STAR_PATH = require("@/assets/svg/star/filled_star_gray.svg");

@Component({
  components: {
    FormInvalidFeedback
  }
})
export default class FiveInputStars extends Vue {
  @Prop({
    type: Number,
    default: null
  })
  value!: number | null;
  @Prop({
    type: Object,
    default: () => ({})
  })
  validationState!: ValidationStateType;

  onClickStar(v: number) {
    this.$emit("input", v);
    this.validationState.handleChange(v);
  }
  get starSrc1() {
    if (this.value && this.value >= 1) {
      return FILLED_STAR_PATH;
    } else {
      return GRAY_STAR_PATH;
    }
  }
  get starSrc2() {
    if (this.value && this.value >= 2) {
      return FILLED_STAR_PATH;
    } else {
      return GRAY_STAR_PATH;
    }
  }
  get starSrc3() {
    if (this.value && this.value >= 3) {
      return FILLED_STAR_PATH;
    } else {
      return GRAY_STAR_PATH;
    }
  }
  get starSrc4() {
    if (this.value && this.value >= 4) {
      return FILLED_STAR_PATH;
    } else {
      return GRAY_STAR_PATH;
    }
  }
  get starSrc5() {
    if (this.value && this.value >= 5) {
      return FILLED_STAR_PATH;
    } else {
      return GRAY_STAR_PATH;
    }
  }
}
</script>
